export function secondsToTime(value: number): string {
  if (isNaN(value) || value < 0) {
    return '00:00:00';
  }

  const hours = Math.floor(value / 3600);
  const minutes = Math.floor((value - hours * 3600) / 60);
  let seconds = value - hours * 3600 - minutes * 60;
  seconds = Math.floor(seconds);

  const sHours = hours < 10 ? '0' + hours : hours.toString();
  const sMinutes = minutes < 10 ? '0' + minutes : minutes.toString();
  const sSeconds = seconds < 10 ? '0' + seconds : seconds.toString();

  return `${sHours}:${sMinutes}:${sSeconds}`;
}

export function getTimestamp(): string {
  const timeStampInMs =
    window.performance &&
    window.performance.now &&
    window.performance.timing &&
    window.performance.timing.navigationStart
      ? window.performance.now() + window.performance.timing.navigationStart
      : Date.now();

  return timeStampInMs.toString();
}

// TODO: Create array of known patterns
const dropboxPattern = /(?:https:\/\/)?(?:(?:[w]+\.)?dropbox.com)\/[s]\/([A-z0-9]+)\/([^/.]+)\.([A-z0-9]{2,4})\?(dl=0)/g;
export function isDropboxUrl(url: string): boolean {
  return dropboxPattern.test(url);
}

export function getShareUrl(url: string): string {
  if (!isDropboxUrl(url)) { return url; }

  return url.replace(dropboxPattern, 'https://dl.dropboxusercontent.com/s/$1/$2.$3?dl=0');
}
